import React from 'react';
import { BlockMatch } from '@llm-ui/react';
import { Loader2 } from 'lucide-react';
import clsx from 'clsx';

interface CodeBlocksProps {
  codeBlocks: BlockMatch[];
  className?: string;
  isLoading?: boolean;
}

const CodeBlocks: React.FC<CodeBlocksProps> = ({
  codeBlocks,
  className,
  isLoading = false,
}) => {
  if (codeBlocks.length === 0 && !isLoading) {
    return null;
  }

  return (
    <div className={clsx('space-y-4', className)}>
      {isLoading && (
        <div className="flex justify-center items-center py-4">
          <Loader2 className="w-6 h-6 animate-spin text-gray-500" />
        </div>
      )}

      {codeBlocks.map((block, index) => {
        const key = `code-block-${index}-${block.startIndex}-${block.endIndex}`;
        const Component = block.block.component;

        if (Component) {
          return (
            <div key={key} className="code-block-wrapper">
              <Component blockMatch={block} />
            </div>
          );
        }

        return (
          <div key={key} className="py-2 px-4 bg-gray-100 rounded">
            <pre>{block.output}</pre>
          </div>
        );
      })}
    </div>
  );
};

export default CodeBlocks;
